import { render, staticRenderFns } from "./SyntaxHighlighter.vue?vue&type=template&id=7cd31247&scoped=true&"
import script from "./SyntaxHighlighter.vue?vue&type=script&lang=ts&"
export * from "./SyntaxHighlighter.vue?vue&type=script&lang=ts&"
import style0 from "./SyntaxHighlighter.vue?vue&type=style&index=0&id=7cd31247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd31247",
  null
  
)

export default component.exports